import MemberAttendanceReportActionTypes from './member-attendance-report.types';

/** ***************** GET MEMBER ATTENDANCE REPORT START *********************** */
export const getMemberAttendanceReportDetailsStart = (getData: any) => ({
	type: MemberAttendanceReportActionTypes.GET_MEMBER_ATTENDANCE_REPORT_LIST_START,
	payload: getData,
});

export const getMemberAttendanceReportDetailsSuccess = (successData: any) => ({
	type: MemberAttendanceReportActionTypes.GET_MEMBER_ATTENDANCE_REPORT_LIST_SUCCESS,
	payload: successData,
});

export const getMemberAttendanceReportDetailsFailure = (failureData: any) => ({
	type: MemberAttendanceReportActionTypes.GET_MEMBER_ATTENDANCE_REPORT_LIST_FAILURE,
	payload: failureData,
});

export const getMemberAttendanceReportDetailsResponseResetStart = () => ({
	type: MemberAttendanceReportActionTypes.GET_MEMBER_ATTENDANCE_REPORT_LIST_RESPONSE_RESET,
});

export const getMemberAttendanceReportDetailsResponseChanged = () => ({
	type: MemberAttendanceReportActionTypes.GET_MEMBER_ATTENDANCE_REPORT_LIST_RESPONSE_CHANGED,
});
/** ***************** GET MEMBER ATTENDANCE REPORT END *********************** */

/** ***************** FETCH MEMBER ATTENDANCE REPORT EXCEL DETAILS START *********************** */
export const fetchMemberAttendanceReportExcelStart = (addData: any) => ({
	type: MemberAttendanceReportActionTypes.GET_MEMBER_ATTENDANCE_REPORT_EXCEL_START,
	payload: addData,
});

export const fetchMemberAttendanceReportExcelSuccess = (successData: any) => ({
	type: MemberAttendanceReportActionTypes.GET_MEMBER_ATTENDANCE_REPORT_EXCEL_SUCCESS,
	payload: successData,
});

export const fetchMemberAttendanceReportExcelFailure = (failureData: any) => ({
	type: MemberAttendanceReportActionTypes.GET_MEMBER_ATTENDANCE_REPORT_EXCEL_FAILURE,
	payload: failureData,
});

export const fetchMemberAttendanceReportResponseExcelResetStart = () => ({
	type: MemberAttendanceReportActionTypes.GET_MEMBER_ATTENDANCE_REPORT_EXCEL_RESPONSE_RESET,
});

export const fetchMemberAttendanceReportResponseExcelResetChanged = () => ({
	type: MemberAttendanceReportActionTypes.GET_MEMBER_ATTENDANCE_REPORT_EXCEL_RESPONSE_CHANGED,
});
/** ***************** FETCH MEMBER ATTENDANCE REPORT EXCEL DETAILS END *********************** */
